import { Promotion } from "@utilities/types";
import { createContext, FC, PropsWithChildren, useState } from "react";

interface PromotionContextProps {
    allPromotions: Promotion[]
    setAllPromotions: (promotions: Promotion[]) => void
    selectedPromotion: Promotion | null
    setSelectedPromotion: (promotion: Promotion | null) => void
}

export const PromotionContext = createContext<PromotionContextProps>({
    allPromotions: [],
    setAllPromotions: () => { },
    selectedPromotion: null,
    setSelectedPromotion: () => { },
});

export const PromotionContextProvider:FC<PropsWithChildren> = ({ children }) => {

    const [allPromotions, setAllPromotions] = useState<Promotion[]>([]);
    const [selectedPromotion, setSelectedPromotion] = useState<Promotion | null>(null);

    return (
        <PromotionContext.Provider value={{
            allPromotions, setAllPromotions,
            selectedPromotion, setSelectedPromotion,
        }}>
            {children}
        </PromotionContext.Provider>
    )
}
